import {DataFetcher} from '@aboutyou/data-fetcher';
import React from 'react';
import {useLinksSection} from '../useGetProductBulkSection';
import {
  GoBackWithCategoryLabelQuickViewProps,
  GoBackWithCategoryLabelQuickViewView,
} from './GoBackWithCategoryLabelQuickViewView';

export const GoBackWithCategoryLabelQuickView: React.FC<
  GoBackWithCategoryLabelQuickViewProps
> = props => {
  return (
    <DataFetcher
      request={useLinksSection()}
      Error={null}
      View={GoBackWithCategoryLabelQuickViewView}
      viewProps={props}
    />
  );
};
